import React, { Component } from 'react';
import { GenericEditPanel, GenericSelect, GenericOption } from 'com-gyf-webcore-userinterfacecomponents';
let DateTimeField = require('react-bootstrap-datetimepicker');
import GlobalHelper from '../../../../Common/Helpers/GlobalHelper';

class Vigencia extends Component {
    constructor(props) {
        super(props);

        this.actualizarNovedadEstado = this.actualizarNovedadEstado.bind(this);
        this.changeDate = this.changeDate.bind(this);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} estadoId
     * @param {any} entidadId
     */
    actualizarNovedadEstado(novedad, estadoId, entidadId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, entidadId)
    }
    /**
     * 
     * @param {any} date
     */
    changeDate(date) {
        if (date != "Invalid date") {
            let resultado = GlobalHelper.CompararFechaDeHoy(date);
            if (resultado.estado) {
                this.props.changeDate(0, this.props.codigoNovedad, date != "" ? resultado.fecha : "");
            } else {
                this.props.changeDataError();
            }
        }
        else {
            this.props.changeDataError();
        }
    }
    /**
     * 
     */
    render() {
        const { props } = this;
        const error = (props.data.dataPickerError == true && props.codigoNovedad == props.data.componenteSeleccionado);
        const errorDataPicker = error ? <label className="error">Debe seleccionar una fecha válida y/o posterior al dia de la fecha.</label> : null

        let vigenciaAlta = props.data.empresaDatos.VigenciaDesdeAlta;
        let vigenciaRenovacion = props.data.empresaDatos.VigenciaDesdeLaRenovaccion;

        let defaultText;
        let labelVigencia;

        //////////Novedad en Descripcion Empresa////////////
        let seEstaEditando = props.data.seEstaEditando;
        let vigenciaPlasticos = undefined;
        let vigenciaPlasticosFormato = undefined;
        let novedadVigenciaPlasticos = undefined;

        if (props.data.novedadesEmpresaDatos) {
            novedadVigenciaPlasticos = props.data.novedadesEmpresaDatos.find(x => x.NovedadCampoCodigo == this.props.codigoNovedad);

            if (novedadVigenciaPlasticos) {
                let esNovedadVigenciaPlasticos = props.data.esNovedadEditada.find(x => x.campoCodigo == this.props.codigoNovedad).editado;
                //novedadVigenciaPlasticos.ValorAnterior = novedadVigenciaPlasticos.ValorAnterior != null ? novedadVigenciaPlasticos.ValorAnterior : "Sin vigencia definida";

                if (!novedadVigenciaPlasticos.ValorAnterior) {
                    novedadVigenciaPlasticos.ValorAnteriorFormateado = "Sin especificar"
                }

                if (esNovedadVigenciaPlasticos) {
                    vigenciaPlasticos = props.data.empresaDatos.FechaTopeRenovacion;
                    if (vigenciaPlasticos != null && vigenciaPlasticos != "") {
                        vigenciaPlasticosFormato = defaultText = GlobalHelper.FormatDate(vigenciaPlasticos);
                    } else {
                        defaultText = "Seleccione una fecha";
                        vigenciaPlasticosFormato = GlobalHelper.FormatDate(new Date().toISOString().slice(0, 19).replace('T', ' '));
                    }
                }
                else {
                    vigenciaPlasticos = novedadVigenciaPlasticos.ValorNovedad;
                    if (vigenciaPlasticos != null && vigenciaPlasticos != "") {
                        vigenciaPlasticosFormato = defaultText = GlobalHelper.FormatDate(vigenciaPlasticos);
                    } else {
                        defaultText = "Seleccione una fecha";
                        vigenciaPlasticosFormato = GlobalHelper.FormatDate(new Date().toISOString().slice(0, 19).replace('T', ' '));
                    }
                }
            }
            else {
                vigenciaPlasticos = props.data.empresaDatos.FechaTopeRenovacion;
                if (vigenciaPlasticos != null && vigenciaPlasticos != "") {
                    vigenciaPlasticosFormato = defaultText = GlobalHelper.FormatDate(vigenciaPlasticos);
                } else {
                    defaultText = "Seleccione una fecha";
                    vigenciaPlasticosFormato = GlobalHelper.FormatDate(new Date().toISOString().slice(0, 19).replace('T', ' '));
                }
            }
        } else {
            vigenciaPlasticos = props.data.empresaDatos.FechaTopeRenovacion;
            if (vigenciaPlasticos != null && vigenciaPlasticos != "") {
                vigenciaPlasticosFormato = defaultText = GlobalHelper.FormatDate(vigenciaPlasticos);
            } else {
                defaultText = "Seleccione una fecha";
                vigenciaPlasticosFormato = GlobalHelper.FormatDate(new Date().toISOString().slice(0, 19).replace('T', ' '));
            }
        }
        ////////////////////////////////////////////////////
        let componenteVigenciaPlasticos = (
            <DateTimeField
                mode="date"
                defaultText={defaultText}
                dateTime={vigenciaPlasticosFormato}
                format={"DD/MM/YYYY"}
                inputFormat={"DD/MM/YYYY"}
                onChange={this.changeDate} />
        );

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <GenericEditPanel
                        componente={componenteVigenciaPlasticos}
                        error={error}
                        permisoUsuario={props.data.funcionesDelUsuario}
                        novedad={novedadVigenciaPlasticos}
                        seEstaEditando={seEstaEditando}
                        textPanel={vigenciaPlasticosFormato || "Sin especificar"}
                        title="Aplica nuevo precio a partir de"
                        value={vigenciaPlasticosFormato}

                        aceptChanges={(value) => this.props.guardarNovedad(value)}
                        confirmarNovedad={() => this.actualizarNovedadEstado(novedadVigenciaPlasticos, 2, props.data.empresaDatos.Id)}
                        changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                        denegarNovedad={() => this.actualizarNovedadEstado(novedadVigenciaPlasticos, 3, props.data.empresaDatos.Id)}
                        mostrarModificaciones={this.props.mostrarModal}
                        revert={this.props.cancelar} />
                    {errorDataPicker}
                </div>
            </div>
        );
    }
}

export default Vigencia;